<template>
  <div class="summary-customer">
    <h2 class="h3"><slot name="headline"></slot></h2>
    <ul class="list-unstyled">
      <li>
        <div class="row">
          <div class="label">
            <slot name="lblFirstName"></slot>
          </div>
          <div>{{ personData.firstName }}</div>
        </div>
      </li>
      <li>
        <div class="row">
          <div class="label">
            <slot name="lblLastName"></slot>
          </div>
          <div>{{ personData.lastName }}</div>
        </div>
      </li>
      <li>
        <div class="row">
          <div class="label">
            <slot name="lblBirthdate"></slot>
          </div>
          <div>{{ personData.birthDate }}</div>
        </div>
      </li>
      <li>
        <div class="row">
          <div class="label">
            <slot name="lblAddress"></slot>
          </div>
          <span class="new-line">{{ addressData.street }} {{ addressData.houseNumber }}</span>
          <span class="new-line">{{ addressData.zip }} {{ addressData.city }}</span>
          <span class="new-line" v-if="addressData.supplement !== ''">{{ addressData.supplement }}</span>
        </div>
      </li>
      <li>
        <div class="row">
          <div class="label">
            <slot name="lblEmail"></slot>
          </div>
          <div>{{ personData.email }}</div>
        </div>
      </li>
      <li>
        <div class="row" v-if="personData.phone">
          <div class="label">
            <slot name="lblPhone"></slot>
          </div>
          <div>{{ personData.phone }}</div>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>

export default {
  name: 'Customer',
  props: {
    process: {
      type: String,
      default: 'ordering'
    }
  },
  computed: {
    personData () {
      return this.$store.getters['checkoutv2/' + this.process + '/_customerData/person'] || null
    },
    addressData () {
      return this.$store.getters['checkoutv2/' + this.process + '/_customerData/address'] || null
    }
  }
}
</script>
